import { fields } from "@monorepo/utils/src/variables/projectsData/InformationSecurityJournal/fields";

export const currentFilters = (): Record<string, string> => ({
  [fields.CREATION_DATE_FROM]: "",
  [fields.CREATION_DATE_TO]: "",
  [fields.TYPE]: "",
  [fields.USERNAME]: "",
  [fields.IP]: "",
});
